import { Tooltip } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface IToolbarButton {
    /**
     * Button children React Nodes
     */
    children: ReactNode;
    /**
     * Condition to disable btn
     */
    disabled?: boolean;
    onClick?: () => void;
    /**
     * Html title for <button/>
     */
    title?: string;
    className?: string;
}

/**
 * Styled button for Lexical Toolbar
 */
const ToolbarButton = ({ disabled, onClick, children, title, className }: IToolbarButton) => {
    const [t] = useTranslation();
    const tooltipTitle = disabled ? t("ContractSettings.InsertArticleOnEmptyLine") : title ?? "";
    return (
        <Tooltip title={tooltipTitle}>
            <button
                disabled={disabled}
                onClick={onClick}
                type="button"
                className={"toolbar-item spaced " + className}
                style={disabled ? { opacity: "0.5" } : {}}
            >
                <div className="format strikethrough">{children}</div>
            </button>
        </Tooltip>
    );
};

export default ToolbarButton;
